import WarningIcon from '@mui/icons-material/Warning';
import { Alert, Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import type { ResultsStaleness } from '../types';

interface TablesStaleBannerProps {
  staleness: ResultsStaleness;
}

export const TablesStaleBanner = ({ staleness }: TablesStaleBannerProps) => {
  const { formatMessage } = useIntl();
  const { reasons } = staleness;

  return (
    <Alert
      severity="warning"
      icon={<WarningIcon fontSize="inherit" />}
      sx={{ py: 0.5 }}
      data-testid="analysis-results-stale-banner"
    >
      {reasons.length > 0 ? (
        <>
          <Typography variant="body2">
            {formatMessage({ id: 'analysisDetail.tables.stale.withReasons' })}
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 4 }}>
            {reasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </Box>
        </>
      ) : (
        formatMessage({ id: 'analysisDetail.tables.stale.fallback' })
      )}
    </Alert>
  );
};
